import { render, staticRenderFns } from "./ArvoreProdutosSelectedItems.vue?vue&type=template&id=0ae1daff"
import script from "./ArvoreProdutosSelectedItems.vue?vue&type=script&lang=js"
export * from "./ArvoreProdutosSelectedItems.vue?vue&type=script&lang=js"
import style0 from "./ArvoreProdutosSelectedItems.vue?vue&type=style&index=0&id=0ae1daff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports